/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { ImportPriceApplyItemDto } from './import-price-apply-item.dto';
import { ImportPriceBatchIdDto } from './import-price-batch-id.dto';
import { ImportPriceFileItemDto } from './import-price-file-item.dto';
import { ImportPriceItemsCountDto } from './import-price-items-count.dto';
import {
  ImportPriceApplyItemMapper,
  ImportPriceBatchIdMapper,
  ImportPriceFileItemMapper,
  ImportPriceFileMapper,
  ImportPriceItemsCountMapper,
} from './import-price-items.mapper';

export interface ImportPriceFilter {
  status: 'UPDATED_ITEM' | 'NEW_ITEM' | 'ERROR';
  batchId: string;
}

@Injectable()
export class ImportPriceItemsRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  getBatchId(file: File): Observable<ImportPriceBatchIdDto> {
    return this.httpPost(`${this.bp}/upload/items/import`, file, ImportPriceFileMapper, ImportPriceBatchIdMapper);
  }

  getGoogleBatchId(id: string): Observable<ImportPriceBatchIdDto> {
    return this.httpGet(`${this.bp}/upload/items/import-from-google?spreadsheetId=${id}`,
                        void 0, void 0, ImportPriceBatchIdMapper);
  }

  findUpdatedItemsAsDataSource(batchId: string, status: string): SlicedDataSource<ImportPriceFileItemDto> {
    return this.createSlicedDataSourceGet(`${this.bp}/upload/items`, {
      batchId,
      status,
    },                                    void 0, arrayOf(ImportPriceFileItemMapper));
  }

  // fixme: status -> enum
  findNewItems(batchId: string, status: string): Observable<ImportPriceFileItemDto[]> {
    return this.httpGet(`${this.bp}/upload/items`, { batchId, status }, void 0, arrayOf(ImportPriceFileItemMapper));
  }

  apply(batchId: string, items: ImportPriceApplyItemDto[]): Observable<ImportPriceApplyItemDto[]> {
    return this.httpPost(`${this.bp}/upload/items/apply/${batchId}`, items, arrayOf(ImportPriceApplyItemMapper));
  }

  itemsCount(batchId: string): Observable<ImportPriceItemsCountDto[]> {
    return this.httpGet(`${this.bp}/upload/count/${batchId}`, void 0, void 0, arrayOf(ImportPriceItemsCountMapper));
  }
}
